/** Styles for Settings > Outreach tools. `ot-` prefix, tokens only. */
export const TOOLS_CSS = `
.ot-page { display: flex; flex-direction: column; gap: var(--space-4); max-width: 720px; }
.ot-block { display: flex; flex-direction: column; gap: var(--space-2); }
.ot-h { margin: 0; font-size: var(--text-base); font-weight: 600; color: var(--text); }
.ot-sub { margin: 0; font-size: var(--text-sm, 12px); color: var(--text-muted); line-height: 1.5; }
.ot-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: var(--space-2); }
.ot-card {
  display: flex; flex-direction: column; gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: var(--bg2); border: 1px solid var(--border); border-radius: var(--radius);
}
.ot-row { display: flex; align-items: center; justify-content: space-between; gap: var(--space-2); flex-wrap: wrap; }
.ot-name { font-weight: 600; font-size: var(--text-base); color: var(--text); }
.ot-dim { color: var(--text-muted); font-size: var(--text-sm, 12px); }
.ot-error { color: var(--red); font-size: var(--text-sm, 12px); white-space: pre-wrap; }
.ot-ok { color: var(--green, var(--text)); font-size: var(--text-sm, 12px); }
.ot-actions { display: flex; flex-wrap: wrap; gap: var(--space-2); align-items: center; }
.ot-actions .add-btn { margin-left: 0; }
.ot-key { display: flex; gap: var(--space-2); flex-wrap: wrap; align-items: center; }
.ot-key input { flex: 1 1 260px; min-width: 0; }
.ot-box {
  display: flex; flex-direction: column; gap: var(--space-1);
  padding: var(--space-2) var(--space-3); border: 1px solid var(--border); border-radius: var(--radius);
}
.ot-map { display: grid; grid-template-columns: minmax(110px, 160px) 1fr; gap: var(--space-2) var(--space-3); align-items: center; }
.ot-map label { font-size: var(--text-sm, 12px); color: var(--text); }
.ot-map select { min-width: 0; }
.ot-table-wrap { overflow-x: auto; }
.ot-table { border-collapse: collapse; font-size: var(--text-sm, 12px); width: 100%; }
.ot-table th, .ot-table td { text-align: left; padding: 4px 8px; border-bottom: 1px solid var(--border); white-space: nowrap; }
.ot-table th { color: var(--text-muted); font-weight: 500; }
.ot-progress { width: 100%; height: 6px; background: var(--bg3); border-radius: 999px; overflow: hidden; }
.ot-progress > div { height: 100%; background: var(--accent); transition: width .2s ease; }
`
